import { Component, ViewChild, OnInit, Inject } from "@angular/core";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { FiltroModel } from 'src/app/models/filtro.model';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import Swal from 'sweetalert2';
import { IRiscosChavesModel } from 'src/app/models/riscos-chaves.model';
import { IUniversoAuditavelModel } from 'src/app/models/universo-auditavel.model';
import { TipoUniversoService } from 'src/app/services/tipo-universo.service';
import { MAT_DIALOG_DATA, MatDialogConfig } from "@angular/material/dialog";
import { ModalSelecaoUniversoAuditavelComponent } from '../modal-selecao-universo-auditavel/modal-selecao-universo-auditavel.component';
import { ModalSelecaoCriterioAvaliacaoComponent } from '../modal-selecao-criterio-avaliacao/modal-selecao-criterio-avaliacao.component';
import { IModeloQuestionarioItemModel } from 'src/app/models/modelo-questionario.model';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { UniversoAuditavelService } from 'src/app/services/universo-auditavel.service';
import { FiltroUniversoAuditavel } from 'src/app/models/filtro-universo-auditavel';
import { TipoUniversoEnum } from 'src/app/models/enum/tipo-universo.enum';
import { IBaseModel } from 'src/app/models/base.model';
import { FiltroCriterioAvaliacaoRiscos } from 'src/app/models/filtro-criterio-avaliacao-riscos.model';
import { ITipoUniversoModel } from 'src/app/models/tipo-universo.model';
import { FiltroRiscosChavesModel } from "../../../../models/filtro-riscos-chaves.model";
import {
  ModalUniversoAuditavelNovaVersaoComponent
} from "../../shared/modal-universo-auditavel-nova-versao/modal-universo-auditavel-nova-versao.component";
import {
  ModalRiscosChavesNovaVersaoComponent
} from "../../shared/modal-risco-chaves-nova-versao/modal-riscos-chaves-nova-versao.component";

@Component({
  selector: 'app-gerar',
  templateUrl: './gerar.component.html',
  styleUrls: ['./gerar.component.scss']
})
export class GerarComponent extends BaseListComponent {

  public filtroUniverso = {} as FiltroUniversoAuditavel;
  public filtroRiscosChavesModel = {} as FiltroRiscosChavesModel;
  public filtroCriterios = {} as FiltroCriterioAvaliacaoRiscos;
	unidadeGestoraId: number;
  universoAuditavelId: number;
	tipoUniversoId: number;
	tipoUniverso: number;
  criterioAvaliacaoId: number;
  public dataSource: any[] = [];
  public universoSelecionado = false;
  public criterioSelecionado = false;
  public modelRiscosChaves : IRiscosChavesModel = {} as IRiscosChavesModel;
  public modelTipoUniverso : ITipoUniversoModel;
  private currentDialogRef: MatDialogRef<any>;
  constructor(
    private riscosChavesService: RiscosChavesServices,
		private universoAuditavelService: UniversoAuditavelService,
		private tipoUniversoService: TipoUniversoService,
		private matDialog: MatDialog,
		private router: Router,
		private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super();
  }

  ngOnInit(): void {

    this.filtroUniverso.unidadeGestoraId = this.sharedService.getId();
    this.unidadeGestoraId = this.sharedService.getId();
	}

  public buscar() {
    this.universoAuditavelService.obterAtivos(this.filtroUniverso).then((res)=>{
      this.dataSource = res.dados.resultado;
    }).catch((err)=> {
      this.exibirMensagemErro(err.mensagem);
    });
  }

	public buscarTipoUniversoAuditavel(){

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '650px';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
    dialogConfig.data = {
      unidadeGestoraId:  this.filtroUniverso.unidadeGestoraId,
      source:  'novo-risco-chaves-universo',
    };

    const modal = this.matDialog.open(ModalSelecaoUniversoAuditavelComponent , dialogConfig );
    modal.afterClosed().subscribe((data) => {
      if(data){
        this.filtroUniverso.pesquisa = data.nomeTipoUniversoAuditavel;
        if(this.filtroUniverso.pesquisa)
           this.universoSelecionado = true;

        this.tipoUniversoId = data.tipoUniversoAuditavelId;
        this.universoAuditavelId = data.id;
      }
    })
	}

  public buscarCriterioAvaliacao(){

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '650px';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
    dialogConfig.data = {
      source:  'novo-risco-chaves-avaliacao-risco',
    };
    const modal = this.matDialog.open(ModalSelecaoCriterioAvaliacaoComponent , dialogConfig );
    modal.afterClosed().subscribe((data) => {

      if(data){
        this.filtroCriterios.pesquisa = data.nome;
        if(this.filtroCriterios)
          this.criterioSelecionado = true;
        this.criterioAvaliacaoId = data.id;
      }
    })
	}

  public async  verificaCriacao(){

    this.filtroRiscosChavesModel.tipoUniversoAuditavelId = this.tipoUniversoId;
    this.filtroRiscosChavesModel.unidadeGestoraId =  this.unidadeGestoraId;
    this.filtroRiscosChavesModel.ativo =  true;

    const itemExiste  = await this.riscosChavesService.obter(this.filtroRiscosChavesModel);

    if(itemExiste.dados.resultado.length > 0){

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "modal-component-nova-versao-risco";
      dialogConfig.width = "650px";
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        source: "novo",
        unidadeGestoraId: this.unidadeGestoraId,
        tipoUniversoId: this.tipoUniversoId,
        univeroAuditavelId: this.universoAuditavelId,
        criterioAvaliacaoId: this.criterioAvaliacaoId,

      };
      this.currentDialogRef = this.matDialog.open(
        ModalRiscosChavesNovaVersaoComponent,
        dialogConfig
      );
      this.currentDialogRef.afterClosed().subscribe((data) => {
        this.buscar();
      });

    }else{
      this.gerar();
    }

  }


  public gerar(){

    if(!this.tipoUniversoId || this.tipoUniversoId == 0){
        this.exibirMensagemErro("Informe o modelo um tipo de Universo Auditável")
        return;
    }
    else {
      this.inserirRiscosChaves(this.tipoUniversoId);
    }


    }
    public async inserirRiscosChaves(id: number){
      try {

        let res: IBaseModel<any> = null;
        const result = await this.tipoUniversoService.obterPorId(id);
        if(result.sucesso){
           this.modelTipoUniverso = result.dados;
           this.modelRiscosChaves.nomeTipoUniverso = this.modelTipoUniverso.nome;
           this.modelRiscosChaves.tipoUniversoAuditavelId = this.tipoUniversoId;
           this.modelRiscosChaves.unidadeGestoraId = this.unidadeGestoraId;
           this.modelRiscosChaves.criterioAvaliacaoId = this.criterioAvaliacaoId;
        }

          res = await this.riscosChavesService.inserir(this.modelRiscosChaves);
          if (res.sucesso) {
              this.router.navigate([`/riscos-chaves-form/${res.dados.id}`]);
            }

      }
      catch  {

      }
    }
  public cancelar() {
    this.router.navigateByUrl(
      `/unidades-gestoras/${this.filtroUniverso.unidadeGestoraId}?aba=4`
    );
  }

}



